import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PATH } from 'src/features/navigation/utils/constants';
import { PricingVersion } from 'src/features/pricingPlan/utils/types';
import NavLink from 'src/registry/components/navigation/NavLink';
import { ICON_MAP } from 'src/utils/constants';
import { getFormattedDateTime } from 'src/utils/getFormattedDateTime';

type PreviousNextVersionLinkProps = {
    version?: PricingVersion | null;
};

const PreviousNextVersionLink = ({ version }: PreviousNextVersionLinkProps) => {
    if (!version) return '-';

    const validToDate = version?.valid_to ?? undefined;
    const { formattedDate: formattedValidFrom } = getFormattedDateTime(version.valid_from);
    const { formattedDate: formattedValidTo } = getFormattedDateTime(validToDate);

    const validToDisplay = version?.valid_to ? `- ${formattedValidTo}` : '';
    const versionLink = `V${version.version_number} - ${formattedValidFrom} ${validToDisplay}`;
    return (
        <NavLink routerClassName={() => ''} to={`/${PATH.ADMINISTRATION}/pricing-plan/${version.id}`}>
            <span className="text-primary-600 flex cursor-pointer flex-row items-center gap-1 font-medium">
                {versionLink}
                <FontAwesomeIcon icon={ICON_MAP.ARROW_UP_RIGHT} />
            </span>
        </NavLink>
    );
};

export default PreviousNextVersionLink;
